import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const BillingProvider = (props) => {
  const api = new API();
  
  const [tableFilter, setTableFilter] = useState({
    month: null,
    year: null,
    salesman_id: null,
    page: 1,
    limit: 10
  });

  const [listLoader, setListLoader] = useState(false);
  const [generateLoader, setGenerateLoader] = useState(false);
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [historyLoader, setHistoryLoader] = useState(false);
  
  const [billingList, setBillingList] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [billDetails, setBillDetails] = useState({ bill: null, payments: [] });
  const [detailsLoader, setDetailsLoader] = useState(false);

  const fetchBillingList = async () => {
    setListLoader(true);
    if(localStorage.getItem("rxdx_admin_login") === "true") {
      await api.getAll("billing_salesman", {...tableFilter}, (err, res) => {    
        if (res?.data?.status === 200) {
          setBillingList(res?.data?.data);
        } else {
          setBillingList([]);
        }
        setListLoader(false);
      });
    } else {
      setListLoader(false);
    }
  };

  const generateBill = async (data) => {
    setGenerateLoader(true);
    const result = localStorage.getItem("rxdx_admin_login") === "true" && await api.create("billing_salesman/generate", data, (err, res) => {    
      if(err) {
        Widget.showMessage("error", err?.response?.data?.message || "Failed to generate bill");
      } else {
        Widget.showMessage("success", res?.data?.message);
        fetchBillingList();
      }
      setGenerateLoader(false);
    });
    return result;
  };

  const makePayment = async (data) => {
    setPaymentLoader(true);
    const result = localStorage.getItem("rxdx_admin_login") === "true" && await api.create("billing_salesman/pay", data, (err, res) => {    
      if(err) {
        Widget.showMessage("error", err?.response?.data?.message || "Payment failed");
      } else {
        Widget.showMessage("success", res?.data?.message);
        fetchBillingList();
      }
      setPaymentLoader(false);
    });
    return result;
  };

  const getPaymentHistory = async (billing_id) => {
    setHistoryLoader(true);
    if(localStorage.getItem("rxdx_admin_login") === "true") {
      await api.getAll(`billing_salesman/history/${billing_id}`, {}, (err, res) => {    
        if (res?.data?.status === 200) {
          setPaymentHistory(res?.data?.data?.data);
        } else {
          setPaymentHistory([]);
        }
        setHistoryLoader(false);
      });
    } else {
      setHistoryLoader(false);
    }
  };

  const getBillDetails = async (billing_id) => {
    setDetailsLoader(true);
    if(localStorage.getItem("rxdx_admin_login") === "true") {
      await api.getAll(`billing_salesman/details/${billing_id}`, {}, (err, res) => {    
        if (res?.data?.status === 200) {
          setBillDetails(res?.data?.data);
        } else {
          setBillDetails({ bill: null, payments: [] });
        }
        setDetailsLoader(false);
      });
    } else {
      setDetailsLoader(false);
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        billingList, setBillingList, fetchBillingList,
        tableFilter, setTableFilter,
        listLoader, setListLoader,
        generateLoader, setGenerateLoader, generateBill,
        paymentLoader, setPaymentLoader, makePayment,
        historyLoader, setHistoryLoader, paymentHistory, getPaymentHistory,
        detailsLoader, setDetailsLoader, billDetails, getBillDetails
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default BillingProvider;
